/* Ten Antennas — navigation links that should open panels, not pages.

   SEARCH. The footer links to /search, which lands on a bare results page with
   its own field — a second, worse search beside the good one in the header.
   The click opens the header panel instead. The href is left intact so
   cmd-click, middle-click and no-JS visitors still reach the real page.

   "CONTACT INFORMATION". The first attempt aimed at links to /pages/contact
   and matched nothing, because this one is not a page link at all — it is a
   POLICY link, /policies/contact-information, sitting in the copyright line
   next to "Powered by Shopify".

   Only the LABEL is changed. The link keeps going to the policy page, and
   deliberately does not open the contact drawer: that page carries the
   trader's legal contact details, which EU consumer law requires to be
   reachable as a page. Turning it into a form would remove the thing the law
   asks for while looking tidier.

   IDEMPOTENT ON PURPOSE. An earlier script here renamed text on every mutation
   and matched its own output, which looped at frame rate and froze every page.
   Nothing below writes unless the value differs, and there is no observer. */
(function () {
  if (window.__taNavLinks) return;
  window.__taNavLinks = true;

  var CONTACT_LABEL = 'Contact us';

  function openSearch() {
    var toggle = document.querySelector('.header__icon--search');
    if (toggle) {
      toggle.click();
      return true;
    }
    var details = document.querySelector('details-modal details');
    if (details) {
      details.setAttribute('open', '');
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a');
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    var href = link.getAttribute('href') || '';
    if (!/^\/search(\/|$|\?)/.test(href)) return;

    if (openSearch()) {
      event.preventDefault();
      var field = document.querySelector('.search-modal input[type="search"]');
      if (field) setTimeout(function () { field.focus(); }, 120);
    }
  });

  function renameContactLink() {
    var links = document.querySelectorAll(
      'a[href*="/policies/contact-information"], a[href*="/pages/contact"]'
    );
    Array.prototype.forEach.call(links, function (a) {
      var text = (a.textContent || '').trim();
      if (!text) return;
      if (text === CONTACT_LABEL) return;
      if (!/contact information/i.test(text)) return;
      a.textContent = CONTACT_LABEL;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renameContactLink);
  } else {
    renameContactLink();
  }
})();
